<template>
  <div v-if="broker != null">

    <!-- <PageHeader label="Refer and Be Rewarded!"></PageHeader> -->
    <Referral />
    <br/><br/><br/><br/>
  </div>
</template>

<script>
  import { EventBus } from '@/shared/event-bus'
  // import PageHeader   from '@/shared/components/headers/PageHeader'
  import Referral     from '@/shared/components/Referral'

  export default {

    components: {
      // PageHeader,
      Referral
    },

    data () {
      return {
        loading: false,
        broker : null,
        link   : null
      }
    },

    created() {
      // am I looking my own?
      if(this.$store.state[this.$store.state.view + 'Module'].broker.id == this.$route.params.brokerId) {
        this.user   = _.cloneDeep(this.$store.state.user)
        this.broker = _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker)
        this.link   = 'https://secure.brokerpad.com.au/auth/register/' + this.broker.first_name.substr(0, 3).toUpperCase() + this.broker.last_name.substr(0, 3).toUpperCase() + '-' + this.broker.id
      }

      else if(this.isUserAdmin()) {
        this.apiGet({
          brokerId : this.$route.params.brokerId
        }, 'broker/detail', (broker) => {
          this.broker = broker
          this.link   = 'https://secure.brokerpad.com.au/auth/register/' + this.broker.first_name.substr(0, 3).toUpperCase() + this.broker.last_name.substr(0, 3).toUpperCase() + '-' + this.broker.id
        })
      }
    },

    methods : {
      onCopy() {
        EventBus.$emit('notification-event', {
          'type'   : 'success',
          'message': "Link copied to your clipboard"
        })
      }
    },
  }
</script>